import { useRef, memo, useState } from "react";
import Modal from "react-modal";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg';

function PlayTestimonial({ isPlayModalOpen, openPlayModal, media }) {
    const audioRef = useRef(null);
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlayPause = () => {
        const player = media?.type === 'audio' ? audioRef.current : videoRef.current;
        if (player) {
            if (isPlaying) {
                player.pause();
                setIsPlaying(false);
            } else {
                player.play();
                setIsPlaying(true);
            }
        }
    };

    return (
        <Modal
            isOpen={isPlayModalOpen}
            ariaHideApp={false}
            style={{
                overlay: {
                    zIndex: 10,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                }
            }}
        >
            <ModalContent className="play-testimonial--modal">
                <div className="modal-header">
                    <span className="modal-title">Play Testimonial</span>
                    <img
                        alt="close"
                        src={close_modal}
                        className="close modal-close"
                        onClick={() => {
                            openPlayModal();
                            setIsPlaying(false);
                            if (audioRef.current) audioRef.current.pause();
                            if (videoRef.current) videoRef.current.pause();
                        }}
                    />
                </div>

                <div className="col-12 conv-pl40 conv-pr40 spled-container fix-filter" style={{ backgroundColor: "#ffffff", overflow: "auto" }}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        {
                            media?.type === 'audio' && (
                                <audio ref={audioRef} src={media?.url} controls style={{ width: "100%", margin: "20px 0" }} />
                            )
                        }
                        {
                            media?.type === 'video' && (
                                <video ref={videoRef} src={media?.url} controls style={{ width: "100%", maxHeight: "400px", margin: "20px 0" }} />
                            )
                        }

                        {/* {media?.url && (
                            <button onClick={handlePlayPause} style={{
                                padding: "10px 20px",
                                background: "#76287C",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer"
                            }}>
                                {isPlaying ? "Pause" : "Play"}
                            </button>
                        )} */}
                    </div>
                </div>
            </ModalContent>
        </Modal>
    );
}

export default memo(PlayTestimonial);
